module.exports = __webpack_public_path__ + "img/dashboardTwo3.ce18ab76.png";